module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/3_6be80ee2955f0a96fb7143e4e0374492.png";